import { render, staticRenderFns } from "./edit-rule-group-input.vue?vue&type=template&id=385e89ac&scoped=true&"
import script from "./edit-rule-group-input.vue?vue&type=script&lang=js&"
export * from "./edit-rule-group-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385e89ac",
  null
  
)

export default component.exports